import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useDialog } from '../../shared/hook/useDialog'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import StudentCourseTable from '../commonfile/StudentCourseTable'
import CustomDivider from '../../shared/utils/CustomDivider'
import CommoneEditStatusAparment from '../commonfile/CommoneEditStatusAparment'
import { useApartmentOptions } from './option/ApartmentOption'
import { formatDateToDDMMYYYY } from '../../shared/formatter'
import { LocationFilterFields } from '../../shared/components/LocationFilterFields'
import CommonContactPersonTable from '../commonfile/CommonContactPersonTable'

const ApartmentList = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const [filters, setFilters] = useState({});
    const [selectedId, setSelectedId] = useState(null);
    const { allApartmentOption } = useApartmentOptions(filters)
    const apartmentColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            width: 250,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_status",
            headerName: "Apartment Status",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "remarks",
            headerName: "Remarks",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "country_name",
            headerName: "Country",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "state_name",
            headerName: "State",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "city_name",
            headerName: "City",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "zone_name",
            headerName: "Zone",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

        {
            field: "created_at",
            headerName: "Created At",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{formatDateToDDMMYYYY(params.value)}</Typography>,
        },
        {
            field: "created_by_name",
            headerName: "Created By",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

        // {
        //     field: "actions",
        //     type: "actions",
        //     headerName: "Actions",
        //     flex: 1,
        //     cellClassName: "actions",
        //     renderCell: (params) => (
        //         <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        //             <Tooltip title="View Detail" placement="top">
        //                 <GridActionsCellItem
        //                     key={0}
        //                     icon={<VisibilityIcon />}
        //                     label="View Detail"
        //                     onClick={() => {
        //                         navigate(`/admin/apartmentdetail/${params?.id}`)
        //                     }}
        //                 />
        //             </Tooltip>
        //         </Box>
        //     ),
        // }
    ];
    const { open, handleClickOpen, handleClose } = useDialog();
    return (
        <Box>
            <TableFilterTemplate
                title="Apartment List"
                columns={apartmentColumns}
                rowsData={allApartmentOption.options || []}
                isLoading={allApartmentOption.isLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                dataGridProps={{
                    onRowClick: (params) => {
                        const role = location.pathname.split("/")[1];
                        if (location.pathname === "/zonalcoordinator/apartmentlist") {
                            setSelectedId(params?.id);
                            handleClickOpen();
                        } else {
                            navigate(`/${role}/apartmentdetail/${params?.id}`);
                        }
                    }
                }}
                renderFilterFields={() => (
                    <>
                        <LocationFilterFields
                            countryField="country_id"
                            stateField="state_id"
                            cityField="city_id"
                            zoneField="zone_id"
                            clusterField="cluster_id"
                            isStoredId={true}
                        />
                    </>
                )}
            />
            {location.pathname === "/zonalcoordinator/apartmentlist" && (

                <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>

                    <Typography variant='h4'>Contact Person List</Typography>
                    <CommonContactPersonTable id={selectedId} />
                    <Typography variant='h4'>Course List</Typography>
                    <CustomDivider size={"1rem"} />
                    {selectedId && <StudentCourseTable id={selectedId} />}
                    <CustomDivider />
                    <Typography variant='h4'>Edit Status</Typography>
                    <CustomDivider size={"1rem"} />
                    <CommoneEditStatusAparment id={selectedId} />
                    <CustomDivider size={"1rem"} />
                </MainDialogBox>

            )}
        </Box>
    )
}

export default ApartmentList